var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTrash = function SvgIconTrash(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / Trash_Full"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6673 8.33333V14.1667M8.33398 8.33333L8.33398 14.1667M3.33398 5H16.6673M15.0007 5V14.8333C15.0007 15.7668 15.0008 16.2335 14.8192 16.59C14.6594 16.9036 14.4041 17.1585 14.0905 17.3183C13.734 17.5 13.2676 17.5 12.3341 17.5H7.66748C6.73406 17.5 6.267 17.5 5.91048 17.3183C5.59688 17.1585 5.3421 16.9036 5.18231 16.59C5.00065 16.2335 5.00065 15.7668 5.00065 14.8333V5H15.0007ZM13.334 5H6.66732C6.66732 4.22343 6.66732 3.83513 6.79418 3.52885C6.96334 3.12047 7.28758 2.79602 7.69596 2.62687C8.00225 2.5 8.39075 2.5 9.16732 2.5H10.834C11.6106 2.5 11.9988 2.5 12.3051 2.62687C12.7135 2.79602 13.0379 3.12047 13.207 3.52885C13.3339 3.83513 13.334 4.22343 13.334 5Z",
    stroke: "#3C3C3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-trash.7cbc8f487fd81686b1f47caf7ff37690.blank.svg";